import React from "react";
import {formatNumber} from "../../../../components/commonmethod/CommonMethod";

function getDepreciationPercent(done, total) {
    const d = Number(done) || 0;
    const t = Number(total) || 0;
    if (t <= 0) return 0;
    return Math.min((d / t) * 100, 100);
}

function formatDepreciationPercent(percent) {
    if (percent >= 100) return "100";
    if (percent < 10) return percent.toFixed(1);
    return String(Math.round(percent));
}

function getDepreciationFillColor(percent) {
    if (percent >= 100) return "#133E87";
    if (percent >= 85) return "#e67e22";
    return "#4393f0";
}

function AssetDepreciationProgressBarRenderer({data}) {
    if (!data) return null;

    const done = Number(data.start) || 0;
    const total = Number(data.end) || 0;
    const percent = getDepreciationPercent(done, total);
    const percentLabel = formatDepreciationPercent(percent);
    const fillColor = getDepreciationFillColor(percent);

    const formattedPrice = formatNumber(data.price);
    const priceLabel = formattedPrice && formattedPrice !== 0 ? `${formattedPrice}원` : "";

    const tooltip = [
        `감가상각 ${done}/${total}년`,
        `${percentLabel}%`,
        priceLabel ? `잔존 ${priceLabel}` : null,
    ].filter(Boolean).join(" · ");

    return (
        <div
            className="flex min-w-0 flex-col justify-center gap-0.5 py-px"
            title={tooltip}
        >
            <div className="flex min-w-0 items-center gap-1.5">
                <div
                    className="relative h-[7px] min-w-0 flex-1 overflow-hidden rounded-full bg-[#e8eef5]"
                    aria-hidden
                >
                    <div
                        className="absolute inset-y-0 left-0 rounded-full transition-[width] duration-300 ease-out"
                        style={{width: `${percent}%`, backgroundColor: fillColor}}
                    />
                </div>
                <span className="shrink-0 text-[11px] font-semibold tabular-nums leading-none text-[#4393f0]">
                    {percentLabel}%
                </span>
            </div>
            {priceLabel ? (
                <span className="truncate text-[10px] leading-none text-[#7a8494]">
                    잔존 {priceLabel}
                </span>
            ) : null}
        </div>
    );
}

function AssetDepreciationPriceNameRenderer({data}) {
    if (data) {
        const price = formatNumber(data);
        return (
            <span>{price !== 0 ? price + "원" : ""}</span>
        )
    }
}

function AssetDepreciationYearNameRenderer({data}) {
    if (data) {
        const price = formatNumber(data);
        return (
            <span>{price !== 0 ? price + "년" : ""}</span>
        )
    }
}

export {AssetDepreciationProgressBarRenderer, AssetDepreciationPriceNameRenderer, AssetDepreciationYearNameRenderer}
